


































































































import Vue from 'vue';
import GrayDivider from '../components/HomePage/GrayDivider.vue';
// import GoogleMap from "../components/HomePage/GoogleMap.vue";
// import ImageCarousel from "../components/HomePage/ImageCarousel.vue";
// import QuickLinks from '../components/HomePage/QuickLinks.vue';
import YoutubeVideo from '../components/HomePage/YoutubeVideo.vue';
// import SubscribeButton from '../components/HomePage/SubscribeButton.vue';
// import TwitterFeed from '../components/HomePage/TwitterFeed.vue';
import HomeSVG from '../assets/i10homepage.svg';
// import NewHomeSVG from '../assets/20260320_Image_for_Home_Page_Links.svg';
import NewHomeSVG from '../assets/20260424_Website_Homepage_Image2.svg';

export default Vue.extend({
  name: 'HomePage',
  components: {
    // GrayDivider,
    // GoogleMap,
    // ImageCarousel,
    // QuickLinks,
    YoutubeVideo,
    // SubscribeButton,
    // TwitterFeed,
    // HomeSVG,
    NewHomeSVG,
  },
  data: () => ({
    viewBtns: {
      viewProjLimBtn: true,
      viewAlt5GBtn: true,
      viewAlt3EBtn: true,
      viewAlt3ABtn: true,
    },
    mapLayers: {
      projectLimits: true,
      alt5GLayer: false,
      alt3ELayer: false,
      alt3ALayer: false,
    },
  }),
  methods: {
    toggle(layers: object) {
      this.mapLayers = { ...this.mapLayers, ...layers };
    },
    openExternalLink(url: string) {
      window.open(url, '_blank');
    },
  },
  mounted() {
    // Attach click handlers to regions inside the imported SVG.
    // The SVG should expose identifiable IDs/classes (e.g. 'green', 'red', 'blue').
    const comp: any = this.$refs.newHomeSvg as any;
    const root: any = comp && comp.$el ? comp.$el : comp;
    if (!root || !root.querySelector) return;

    // Inject transparent SVG rect overlays (created at runtime) so a single rectangle
    // covers the icon, arrow, and text for each area. This avoids editing the source SVG file.
    try {
      const svgEl: SVGSVGElement | null = (root.querySelector && root.querySelector('svg')) || root;
      const svgNS = 'http://www.w3.org/2000/svg';

      const createOverlayFromSelectors = (
        id: string,
        selectors: string[],
        ariaLabel: string,
        cb: () => void
      ) => {
        try {
          if (!svgEl) return;

          // Collect matching elements inside the SVG
          const elems: Element[] = [];
          for (const s of selectors) {
            try {
              const found = Array.from(svgEl.querySelectorAll(s) as NodeListOf<Element>);
              found.forEach((f) => elems.push(f));
            } catch (err) {
              // ignore invalid selector
            }
          }

          // Try to include obvious related elements by id fragments (fallback)
          if (elems.length === 0 && selectors.length) {
            const frag = selectors[0].replace(/[^a-z0-9]/gi, '').slice(0, 8);
            try {
              const extra = Array.from(svgEl.querySelectorAll(`[id*="${frag}"]`));
              extra.forEach((e) => elems.push(e));
            } catch (err) {
              // ignore
            }
          }

          // Compute union bbox via getBBox when possible
          let minX = Infinity,
            minY = Infinity,
            maxX = -Infinity,
            maxY = -Infinity;
          for (const el of elems) {
            try {
              // Some SVG elements (use, path, text) support getBBox
              const geom: any = (el as any).getBBox ? (el as any).getBBox() : null;
              if (geom) {
                minX = Math.min(minX, geom.x);
                minY = Math.min(minY, geom.y);
                maxX = Math.max(maxX, geom.x + geom.width);
                maxY = Math.max(maxY, geom.y + geom.height);
              }
            } catch (err) {
              // ignore
            }
          }

          // Fallback: if no bbox found, try to read first <use> x/y attributes
          if (!isFinite(minX) && elems.length) {
            const first = elems[0];
            const fx = parseFloat((first.getAttribute && first.getAttribute('x')) || '0') || 0;
            const fy = parseFloat((first.getAttribute && first.getAttribute('y')) || '0') || 0;
            minX = fx;
            minY = fy;
            maxX = fx + 700;
            maxY = fy + 200;
          }

          if (!isFinite(minX)) return;

          const pad = Math.max(8, Math.min(40, (maxX - minX) * 0.03));
          const rx = minX - pad;
          const ry = minY - pad;
          const rw = Math.max(16, maxX - minX + pad * 2);
          const rh = Math.max(16, maxY - minY + pad * 2);

          const r = document.createElementNS(svgNS, 'rect');
          r.setAttribute('id', id);
          r.setAttribute('x', String(rx));
          r.setAttribute('y', String(ry));
          r.setAttribute('width', String(rw));
          r.setAttribute('height', String(rh));
          r.setAttribute('fill', '#000');
          r.setAttribute('fill-opacity', '0');
          r.setAttribute('role', 'link');
          r.setAttribute('aria-label', ariaLabel);
          r.setAttribute('tabindex', '0');
          r.setAttribute('focusable', 'true');
          (r as any).style.cursor = 'pointer';
          (r as any).style.pointerEvents = 'all';

          // Make matched elements decorative for assistive tech and remove pointer-events so overlay receives clicks
          for (const el of elems) {
            try {
              el.setAttribute && el.setAttribute('aria-hidden', 'true');
              el.setAttribute && el.setAttribute('focusable', 'false');
              if ((el as HTMLElement).style) (el as any).style.pointerEvents = 'none';
            } catch (err) {
              // ignore
            }
          }

          const activate = () => {
            try {
              cb();
            } catch (err) {
              // ignore
            }
          };

          r.addEventListener('click', activate);
          r.addEventListener('keydown', (ev: KeyboardEvent) => {
            if (ev.key === 'Enter' || ev.key === ' ' || ev.key === 'Spacebar') {
              ev.preventDefault();
              activate();
            }
          });

          svgEl.appendChild(r);
        } catch (err) {
          // ignore per-area errors
        }
      };

      // NEW top NEPA (April 2026) - explicit new overlay for the 202604_NEPA group
      createOverlayFromSelectors(
        'LinkArea-202604-NEPA',
        [
          // '[id="Link_to_NEPA_Re-Eval_Image"]',
          // '[id*="Link_to_NEPA_Re-Eval_Image"]',
          // '[id="202604_NEPA"]',
          // '[id*="202604_NEPA"]',
          '[data-name="202604_NEPA"]',
        ],
        'Approved Re-evaluation (April 2026), open document',
        () => {
          const base = 'https://i10-louisiana-files.s3.us-east-2.amazonaws.com/Documents/';
          const file = 'Approved_Reevaluation2.pdf';
          const url = base + file.replace(/ /g, '+');
          this.openExternalLink(url);
        }
      );

      // NEPA (original / older) - explicit selector for 202503_NEPA as well
      createOverlayFromSelectors(
        'LinkArea-202503-NEPA',
        [
          // '[id="202503_NEPA"]',
          // '[id*="202503_NEPA"]',
          '[data-name="202503_NEPA"]',
          // '[id="Link to NEPA Re-Eval"]',
          // '[href="#img4"]',
          // '[id*="NEPA"]',
          // '[id*="NEPA RE-EVALUATION"]',
          // '[id*="CLICK HERE FOR THE NEPA"]',
        ],
        'NEPA Re-evaluation, open document',
        () => {
          const base = 'https://i10-louisiana-files.s3.us-east-2.amazonaws.com/Documents/';
          const file = '2025_0311_nepa re eval w stamp and signature.pdf';
          const url = base + file.replace(/ /g, '+');
          this.openExternalLink(url);
        }
      );

      // ROD (middle)
      createOverlayFromSelectors(
        'LinkArea-ROD',
        [
          // '[id="ROD"]',
          // '[id*="ROD"]',
          '[data-name="ROD"]',
          // '[id="ROD"]',
          // '[data-name="ROD"]',
          // '[id="Link to ROD"]',
          // '[href="#img3"]',
          // '[id*="ROD"]',
          // '[id*="RECORD OF DECISION"]',
          // '[id*="CLICK HERE FOR THE RECORD"]',
        ],
        'Record of Decision, open document',
        () => {
          const base = 'https://i10-louisiana-files.s3.us-east-2.amazonaws.com/Documents/';
          const file = 'H.003931 ROD_2024_0130 Complete.pdf';
          const url = base + file.replace(/ /g, '+');
          this.openExternalLink(url);
        }
      );

      // FEIS (bottom)
      createOverlayFromSelectors(
        'LinkArea-FEIS',
        [
          // '[id="FEIS"]',
          // '[id*="FEIS"]',
          '[data-name="FEIS"]',
          // '[id="Link_to_FEIS_Image"]',
          // '[id="FEIS"]',
          // '[data-name="FEIS"]',
          // '[id="Link to FEIS"]',
          // '[href="#img5"]',
          // '[id*="FEIS"]',
          // '[id*="FINAL ENVIRONMENTAL IMPACT STATEMENT"]',
          // '[id*="CLICK HERE FOR THE FINAL"]',
        ],
        'Final Environmental Impact Statement, open document',
        () => {
          const base = 'https://i10-louisiana-files.s3.us-east-2.amazonaws.com/Documents/';
          const file = 'H.003931+FEIS+09112023.pdf';
          const url = base + file.replace(/ /g, '+');
          this.openExternalLink(url);
        }
      );
    } catch (err) {
      // ignore overlay injection errors
    }

    // Reusable helper to mark an element clickable and attach handler (idempotent)
    const makeClickable = (e: Element, handler: () => void) => {
      try {
        if (e.getAttribute && e.getAttribute('data-clickable-attached')) return;
        if (e.setAttribute) e.setAttribute('data-clickable-attached', '1');
        (e as any).style.cursor = 'pointer';
        (e as any).style.pointerEvents = 'auto';
      } catch (err) {
        // ignore styling/errors
      }
      try {
        e.addEventListener('click', handler);
      } catch (err) {
        // ignore
      }
    };

    const attachFirstMatch = (names: string[], handler: () => void) => {
      for (const s of names) {
        try {
          const el: Element | null = root.querySelector(s);
          if (el) {
            makeClickable(el, handler);

            // If this is a <use> element, also attach to the referenced fragment inside the SVG
            try {
              const href =
                (el.getAttribute && (el.getAttribute('href') || el.getAttribute('xlink:href'))) ||
                '';
              if (href && href.startsWith('#')) {
                const target = root.querySelector(href);
                if (target && target !== el) makeClickable(target, handler);
              }
            } catch (err) {
              // ignore
            }

            // Also attempt to attach to any obvious companion elements (paths/text) that contain the same id fragment
            try {
              const elId = (el as Element).id;
              if (elId) {
                const other = root.querySelector(`[id*="${elId}"]`);
                if (other && other !== el) makeClickable(other, handler);
              }
            } catch (err) {
              // ignore
            }

            return true;
          }
        } catch (e) {
          // ignore invalid selectors
        }
      }
      return false;
    };

    // Attach by visible text content (searches text/tspan nodes and elements' textContent)
    const attachByText = (substrings: string[], handler: () => void) => {
      try {
        const nodes = Array.from(root.querySelectorAll('text, tspan, [id]')) as Element[];
        for (const n of nodes) {
          const txt = (n.textContent || '').trim();
          if (!txt) continue;
          const lower = txt.toLowerCase();
          for (const sub of substrings) {
            if (lower.indexOf(sub.toLowerCase()) !== -1) {
              makeClickable(n, handler);
              break;
            }
          }
        }
      } catch (err) {
        // ignore
      }
    };

    // Green -> reevaluation
    attachFirstMatch(['#green', '.green', '[id*=green]'], () => {
      this.$router.push({ path: '/documentlibrary', hash: '#reevaluation' });
    });

    // Also support older/other exports that use <use> elements or different ids
    // NEW: explicit attach for the April 2026 NEPA overlay (topmost)
    attachFirstMatch(
      ['[id="202604_NEPA"]', '[id*="202604_NEPA"]', '[id*=202604]', '[data-name="202604_NEPA"]'],
      () => {
        const base = 'https://i10-louisiana-files.s3.us-east-2.amazonaws.com/Documents/';
        const file = 'Approved_Reevaluation2.pdf';
        const url = base + file.replace(/ /g, '+');
        this.openExternalLink(url);
      }
    );

    // NEPA Re-Eval (many SVG exports use href="#img4" or ids with spaces)
    attachFirstMatch(
      [
        '[id="202503_NEPA"]',
        '[id*="202503_NEPA"]',
        '[data-name="202503_NEPA"]',
        '[id="Link to NEPA Re-Eval"]',
        '[id*=Re-Eval]',
        '[id*=reeval]',
        '[href="#img4"]',
        '[xlink\\:href="#img4"]',
        '[id*="NEPA"]',
        '[id="Teal Arrow"]',
        '[id*="NEPA RE-EVALUATION"]',
        '[id*="CLICK HERE FOR THE NEPA"]',
      ],
      () => {
        const base = 'https://i10-louisiana-files.s3.us-east-2.amazonaws.com/Documents/';
        const file = '2025_0311_nepa re eval w stamp and signature.pdf';
        const url = base + file.replace(/ /g, '+');
        this.openExternalLink(url);
      }
    );

    // Also explicitly attach to visible path/text IDs that can sit above the <use> elements
    // ROD arrow/text overlays
    attachFirstMatch(
      ['[id="Maroon Arrow"]', '[id*="RECORD OF DECISION"]', '[id*="CLICK HERE FOR THE RECORD"]'],
      () => {
        const base = 'https://i10-louisiana-files.s3.us-east-2.amazonaws.com/Documents/';
        const file = 'H.003931 ROD_2024_0130 Complete.pdf';
        const url = base + file.replace(/ /g, '+');
        this.openExternalLink(url);
      }
    );

    // NEPA Re-Eval arrow/text overlays
    attachFirstMatch(
      ['[id="Teal Arrow"]', '[id*="NEPA RE-EVALUATION"]', '[id*="CLICK HERE FOR THE NEPA"]'],
      () => {
        const base = 'https://i10-louisiana-files.s3.us-east-2.amazonaws.com/Documents/';
        const file = '2025_0311_nepa re eval w stamp and signature.pdf';
        const url = base + file.replace(/ /g, '+');
        this.openExternalLink(url);
      }
    );

    // FEIS arrow/text overlays
    attachFirstMatch(
      [
        '[id="Navy Arrow"]',
        '[id*="FINAL ENVIRONMENTAL IMPACT STATEMENT"]',
        '[id*="CLICK HERE FOR THE FINAL"]',
      ],
      () => {
        const base = 'https://i10-louisiana-files.s3.us-east-2.amazonaws.com/Documents/';
        const file = 'H.003931+FEIS+09112023.pdf';
        const url = base + file.replace(/ /g, '+');
        this.openExternalLink(url);
      }
    );

    // Red -> final EIS
    attachFirstMatch(['#red', '.red', '[id*=red]'], () => {
      this.$router.push({
        path: '/documentlibrary',
        hash: '#final-eis-september-2023-rod-january-2024',
      });
    });

    // ROD link (may be a <use> with id containing spaces or href to an image id)
    attachFirstMatch(
      [
        '[id="ROD"]',
        '[data-name="ROD"]',
        '[id="Link to ROD"]',
        '[id*=ROD]',
        '[href="#img3"]',
        '[xlink\\:href="#img3"]',
        '[id*="ROD"]',
        '[id="Maroon Arrow"]',
        '[id*="RECORD OF DECISION"]',
        '[id*="CLICK HERE FOR THE RECORD"]',
      ],
      () => {
        const base = 'https://i10-louisiana-files.s3.us-east-2.amazonaws.com/Documents/';
        const file = 'H.003931 ROD_2024_0130 Complete.pdf';
        const url = base + file.replace(/ /g, '+');
        this.openExternalLink(url);
      }
    );

    // Blue -> final EIS
    attachFirstMatch(['#blue', '.blue', '[id*=blue]'], () => {
      this.$router.push({
        path: '/documentlibrary',
        hash: '#final-eis-september-2023-rod-january-2024',
      });
    });

    // FEIS link (use element or id variants)
    attachFirstMatch(
      [
        '[id="FEIS"]',
        '[data-name="FEIS"]',
        '[id="Link to FEIS"]',
        '[id*=FEIS]',
        '[href="#img5"]',
        '[xlink\\:href="#img5"]',
        '[id*="FEIS"]',
        '[id="Navy Arrow"]',
        '[id*="FINAL ENVIRONMENTAL IMPACT STATEMENT"]',
        '[id*="CLICK HERE FOR THE FINAL"]',
      ],
      () => {
        const base = 'https://i10-louisiana-files.s3.us-east-2.amazonaws.com/Documents/';
        const file = 'H.003931+FEIS+09112023.pdf';
        const url = base + file.replace(/ /g, '+');
        this.openExternalLink(url);
      }
    );
  },
});
